type LowercaseKeys<T> = {
  [K in keyof T as Lowercase<K & string>]: T[K];
};

export function normalizeQuery<T>(searchParams?: URLSearchParams, params?: T): LowercaseKeys<T> {
  const normalized: Partial<LowercaseKeys<T>> = {};

  if (searchParams) {
    searchParams.forEach((value, key) => {
      const lowerCasedKey = key.toLowerCase() as keyof LowercaseKeys<T>;
      (normalized[lowerCasedKey] as unknown) = value;
    });
  }

  if (params) {
    Object.keys(params).forEach((key) => {
      const lowerCasedKey = key.toLowerCase() as keyof LowercaseKeys<T>;
      (normalized[lowerCasedKey] as unknown) = params[key as keyof T];
    });
  }

  return normalized as unknown as LowercaseKeys<T>;
}
